/**
 * 全局配置 — Web端
 * 切换环境只需改这一个文件
 */
// 生产环境
var apiBase = 'https://parse.huanyings.com/api-clone'
// 本地测试（取消注释下面这行，注释上面那行）
// var apiBase = 'http://localhost:8080/api-clone'

export default { apiBase }



// WEBPACK FOOTER //
// ./src/api/config.js